module.exports = __webpack_public_path__ + "static/media/terms-conditions.40abc109.pdf";